import * as React from 'react';
import b_ from 'b_';
import IdeaChart from 'components/IdeaChart';
import { IdeaTopCardFragment } from './__generated__/IdeaTopCardFragment';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Wrapper } from './components/Wrapper';

import './index.scss';

const b = b_.with('idea-top-card');

interface Props {
  idea: IdeaTopCardFragment;
  isIdeaLandingCard?: boolean;
  chartBaseLine?: boolean;
  className?: string;
}

export const IdeaTopCard: React.FC<Props> = ({
  idea,
  chartBaseLine,
  isIdeaLandingCard,
  className,
}) => {
  const url = `/investments/idea/${idea.ideaType.toLowerCase()}/${idea.id}`;

  return (
    <div className={b()} data-testid="idea-top-card">
      <Wrapper url={url} className={className} isIdeaLandingCard={isIdeaLandingCard}>
        <div className={b('graph')}>
          <IdeaChart ideaId={idea.id} baseLine={chartBaseLine} />
        </div>
        <div className={b('content')}>
          <Header idea={idea} />
          <Footer idea={idea} isIdeaLandingCard={isIdeaLandingCard} />
        </div>
      </Wrapper>
    </div>
  );
};
